export default "__VITE_ASSET__025b4cce__"